import { AbstractControl, ValidationErrors } from '@angular/forms';

export function linkedInUrlValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const linkedInUrlRegex = /^https:\/\/(?:www\.|[a-z]{2,3}\.)?linkedin\.com\/(?:in|pub|company|school)\/[A-Za-z0-9][A-Za-z0-9._~:%+-]*(?:\/[A-Za-z0-9._~:%+-]*)*\/?(?:\?[\w\-._~:/?#[\]@!$&'()*+,;=%]*)?(?:#[\w\-._~:/?#[\]@!$&'()*+,;=%]*)?$/.test(control.value);
  return linkedInUrlRegex ? null : { 'invalidUrl': true };
}